module.exports = __webpack_public_path__ + "static/media/Krish-Hindi.b4350969.svg";